import { Component } from '@angular/core';
import { TourismEventsComponent } from '../tourism-events.common';
import { CategoryEvent } from '../tourism-events.model';

@Component({
	selector: 'app-tourism-events-stop',
	templateUrl: './tourism-events-stop.component.html',
	styleUrls: ['./tourism-events-stop.component.css'],
})
export class TourismEventsStopComponent extends TourismEventsComponent {
	errors = {
		name: '',
		vehicles: [],
		owner: '',
		date_from: '',
		date_to: '',
		category: '',
		text_program: '',
	};

	protected defaultValues() {
		this.event.status = 'PRELIMINARY';
		this.event.type = 'EVENT';
		this.event.category = CategoryEvent.ENSILAGE;
		this._serviceEvent.organization.subscribe((result) => {
			this.event.client = result;
			this.event.clientEvent = {
				client: result.id,
				event: null,
				isOrganization: '1',
			};
		});
	}

	protected convertDataOnSave(data) {
		data.text_program = 'Miejsce dokumentów i kluczyków:\n' + this.event.text_program;
		data.startPlace = this.event.name;
		data.endPlace = this.event.name;
		return data;
	}
}
